module.exports = __webpack_public_path__ + "img/powered-by-dark.898abbd3.svg";